import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  item: {
    // width: 240,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.secondary.dark,
      width: '100%',
      overflow: 'hidden',
      borderRadius: 0,
      '& $title': {
        // fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette.secondary.main,
      },
      '& $submenuTitle': {
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette.secondary.main,
      },
      '& $icon': {
        color: theme.palette.secondary.main,
      },

      '& $openSubMenuIcon': {
        color: theme.palette.secondary.main,
      },
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.secondary.dark,
      '& $openSubMenuIcon': {
        color: theme.palette.secondary.dark,
      },
    },
    '&.MuiListItem-root.Mui-selected:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
    '&.MuiListItem-gutters': {
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
  button: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 4,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    color: theme.palette.common.white,
  },
  iconSelected: {
    color: theme.palette.secondary.dark,
  },
  title: {
    marginRight: 'auto',
    marginLeft: -20,
    color: theme.palette.common.white,
    textTransform: 'none',
    letterSpacing: '0.1em',
    fontWeight: 700,
    textAlign: 'left',
  },
  titleSelected: {
    marginRight: 'auto',
    marginLeft: -20,
    color: theme.palette.secondary.dark,
    textTransform: 'none',
    letterSpacing: '0.1em',
    fontWeight: 'bold',
    textAlign: 'left',
  },
  openSubMenuIcon: {
    color: theme.palette.common.white,
  },
  submenuTitle: {
    color: theme.palette.common.white,
    paddingLeft: 38,
    textAlign: 'left',
    fontWeight: 400,
    fontSize: 14,
    textTransform: 'capitalize',
  },
}));
